
import requestBase from '../requesBase';
const payment = 'payment'

const payModule = {
  // 获取付款二维码
  getPayLink(data,callback) {
    requestBase.post(payment + '/pay-link', data).then(res => {
      callback(res);
    })
  },
  // 获取付款结果
  getPayResult(data, callback) {
    requestBase.post(payment + '/pay-result', data).then(res => {
      callback(res);
    })
  },
  // 我的加油包权益
  mineRefuelEquity(data, callback) {
    requestBase.post('site/user-asset', data).then(res => {
      callback(res);
    })
  },
}

export default payModule;